/**
 * React hook to allow search param saved tabs
 */

import { useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

interface UseTabOptions {
  default: string;
  key?: string,
}

const useTab = (opts: UseTabOptions) : [string, (newTab?: string) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramTab = searchParams.get(opts?.key || 'tab');

  const [tab, setTab] = useState<string>(paramTab || opts.default);

  const setTabFn = useMemo(() =>
    (newTab?: string) => {
      if (newTab) {
        setTab(newTab);
        setSearchParams({ [opts?.key || 'tab']: newTab }, { replace: true });
      } else {
        setTab(opts.default);
        setSearchParams({}, { replace: true });
      }
    },
  []);

  return [tab, setTabFn];
};

export default useTab;
